<template>
    <div
        class="m-product"
        :class="{
            'm-product--active':
                weekDayOrder &&
                weekDayOrder.addressId === addressId &&
                showInModal,
            'm-product--inModal': showInModal
        }"
        draggable
        @dragstart="startDrag($event)"
    >
        <div class="m-product__overlay"  @click="addAnimation(product, $event)">
            <div v-show="!showInModal" class="m-product__drag"></div>
            <div
                v-if="amount > 0"
                class="m-product__close"
                @click="showInModal ? remove() : openModalRemoveProduct()"
            ></div>
            <figure
                class="m-product__image"
                @click="showInModal ? add() : false"
            >
                <img
                    v-if="product.image_url"
                    :src="`${apiUrl}${product.image_url}`"
                    alt=""
                    class="m-product__imageImg"
                />
                <img
                    v-else
                    src="@/assets/pack.jpg"
                    alt=""
                    class="m-product__imageImg"
                />
            </figure>
            <div class="m-product__dataWrapper">
                <p class="m-product__title">
                    <span v-if="product.desc_html" class="a-tooltip__icon">
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 7 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0)" fill="#fff">
                                <path
                                    d="M0 6.614c.207-.394.276-.772.483-.854 1.103-.443 2.224-.886 3.465-.64 1.259.247 1.914 1.018 1.724 2.216-.19 1.149-.551 2.265-.827 3.397-.12.509-.293 1.001-.38 1.51-.19 1.132.294 1.559 1.5 1.362.225-.033.449-.082.673-.115.069.05.12.115.19.164-.259.263-.466.624-.776.772-.983.443-2.018.755-3.138.508-1.259-.279-1.948-1.017-1.759-2.215.207-1.28.604-2.527.931-3.791.104-.443.242-.903.293-1.346.087-.935-.362-1.296-1.345-1.149-.275.033-.551.082-1.034.18zM5.172 0C6.26.05 7.07.87 7 1.855c-.069.968-.966 1.657-2.069 1.608-1.034-.05-1.862-.837-1.845-1.773C3.121.706 4.052-.05 5.172 0z"
                                ></path>
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <path d="M0 0h7v15H0V0z" fill="#fff"></path>
                                </clipPath>
                            </defs>
                        </svg>
                    </span>
                    <span
                        v-if="product.desc_html"
                        class="a-tooltip__popup"
                        v-html="product.desc_html"
                    ></span>
                    {{ product.name }}
                </p>
                <div class="m-product__data">
                    <p v-if="packagePrice" class="m-product__price">
                        {{ packagePrice.toPLN() }}
                    </p>
                    <p
                        v-if="amount && showButtons"
                        class="m-product__amount a-label"
                    >
                        {{ amount }} szt.
                    </p>
                    <div v-if="showButtons" class="m-product__actions">
                        <div class="m-product__actionsControls">
                            <span
                                class="material-icons m-product__subtract"
                                @click="amount > 0 ? subtract() : false"
                                >remove</span
                            >
                            <span>{{ amount }} szt.</span>
                            <span
                                class="material-icons m-product__add"
                                @click="add"
                                >add</span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        },
        dayInWeek: {
            type: Number,
            required: true
        },
        addressId: {
            type: Number,
            default: 0
        },
        showInModal: {
            type: Boolean,
            default: false
        },
        isOneTimeOrder: {
            type: Boolean,
            required: false
        },
        showButtons: {
            type: Boolean,
            default: true
        },
        noOverlay: {
            type: Boolean,
            default: true
        },
        upsell: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            animationTimeout: 300
        }
    },
    computed: {
        apiUrl() {
            return `${process.env.VUE_APP_API}b2b/v1`
        },
        amount() {
            return this.weekDayOrder ? this.weekDayOrder.amount : 0
        },
        weekDayOrder() {
            return this.$store.getters
                .weekDayOrder(this.dayInWeek, this.addressId)
                .find(item => item.product.id === this.product.id)
        },
        packagePrice() {
            return this.$store.getters.packagePrice(
                this.product.id,
                this.dayInWeek,
                this.addressId,
                this.isOneTimeOrder
            )
        },
        weekOrderId() {
            return this.$store.getters.weekOrders.findIndex(
                item =>
                    item.addressId === this.addressId &&
                    item.dayInWeek === this.dayInWeek &&
                    item.product.id === this.product.id
            )
        }
    },
    mounted() {
        if (!this.noOverlay) {
            const parent = this.$el.querySelector('.m-product__overlay')
            parent.classList.add('m-product__overlay--appear')
            setTimeout(() => {
                parent.classList.remove('m-product__overlay--appear')
            }, this.animationTimeout)
        }
    },
    beforeUnmount() {
        if (!this.noOverlay) {
            const parent = this.$el.querySelector('.m-product__overlay')
            parent.classList.add('m-product__overlay--appear')
            setTimeout(() => {
                parent.classList.remove('m-product__overlay--appear')
            }, this.animationTimeout)
        }
    },
    methods: {
        addAnimation(item, $event) {
            if (this.upsell) {
                const parent = $event.path.find(item => {
                    return item.classList.contains('m-product__overlay')
                })
                parent.classList.add('m-product__overlay--appear')
                setTimeout(() => {
                    parent.classList.remove('m-product__overlay--appear')
                    const upsellModule = document.querySelector('.o-dashboardCalendarModal__cartList')
                    upsellModule.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
                }, this.animationTimeout)
            }
        },
        add() {
            this.$store.dispatch('applyProductToCart', {
                dayInWeek: this.dayInWeek,
                addressId: this.addressId,
                product: this.product,
                amount: this.amount + 1
            })
            this.modalchangesHaveBeenMade()
        },
        subtract() {
            this.$store.dispatch('applyProductToCart', {
                dayInWeek: this.dayInWeek,
                addressId: this.addressId,
                product: this.product,
                amount: this.amount - 1
            })
            this.modalchangesHaveBeenMade()
        },
        remove() {
            this.$store.dispatch('applyProductToCart', {
                dayInWeek: this.dayInWeek,
                addressId: this.addressId,
                product: this.product,
                amount: 0
            })
            this.modalchangesHaveBeenMade()
        },
        modalchangesHaveBeenMade() {
            if (this.showInModal) {
                this.$store.dispatch('modalchangesHaveBeenMade', true)
            }
        },
        openModalRemoveProduct() {
            this.$store.dispatch('modalShow', {
                name: 'productRemove',
                payload: {
                    dayInWeek: this.dayInWeek,
                    addressId: this.addressId,
                    product: this.product
                }
            })
        },
        startDrag(evt) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('orderId', this.weekOrderId)
            this.$store.dispatch('setDragPackageDayInWeek', this.dayInWeek)
        }
    }
}
</script>
